export enum MicrodatasContactPoints {
  DE = '+49-(0)-3056-795603',
  EN = '+44-203-608-9842',
  ES = '+34-900-838-176',
  FR = '+33-9-70-25-37-37',
  IT = '848-124-101',
  UK = '+44-203-608-9842',
  US = '+1-855-84-21-82-2',
  WW = '+1-855-84-21-82-2'
}
